import React from "react";
import { Box, Typography } from "@mui/material";

type SkippedStepOverlayProps = {
  message: string;
};

const SkippedStepOverlay = ({ message }: SkippedStepOverlayProps) => (
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      backgroundColor: "rgba(245, 245, 245, 0.72)",
      zIndex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Typography
      sx={{
        px: "1rem",
        py: "0.5rem",
        borderRadius: "999px",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        color: "text.secondary",
        fontWeight: 600,
      }}
    >
      {message}
    </Typography>
  </Box>
);

export default SkippedStepOverlay;
